module.exports = __webpack_public_path__ + "static/media/1013133.5957f910.png";